import { 
	SEND_EMAIL
} from "./Constants"

export const sendEmail = (dispatch, params) => {
  dispatch({ type: SEND_EMAIL, payload: { body: params } })
}